export default "__VITE_ASSET__Dtv5hFMB__"